export default "__VITE_ASSET__6fdc8b85__"